import * as React from 'react'
import { SVGProps } from 'react'
const SvgBackward5 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.417 9.018a1.062 1.062 0 1 1 1.65 1.336c-1.607 1.992-2.503 4.353-2.588 6.827-.228 6.372 4.778 11.748 11.164 11.961 6.386.228 11.748-4.779 11.975-11.15.228-6.372-4.778-11.748-11.164-11.961-.81-.028-1.664.043-2.589.228-.057.014-.114 0-.17 0a1.086 1.086 0 0 1-.47.113.995.995 0 0 1-.668-.241 1.077 1.077 0 0 1-.17-1.494l2.815-3.513a1.064 1.064 0 0 1 1.493-.17c.456.37.527 1.038.171 1.493l-1.18 1.465c.27-.014.554-.029.825-.014 7.552.256 13.482 6.627 13.212 14.18-.27 7.551-6.627 13.482-14.18 13.212-7.551-.27-13.482-6.628-13.212-14.18a13.694 13.694 0 0 1 3.086-8.092Z"
      fill="currentColor"
    />
    <path
      d="M16.541 22.998h-3.257a1.074 1.074 0 0 1-1.066-1.067c0-.583.483-1.067 1.066-1.067h3.257a1.11 1.11 0 0 0 1.11-1.109 1.11 1.11 0 0 0-1.11-1.11h-3.257c-.34 0-.668-.17-.867-.44-.2-.27-.256-.64-.142-.967l1.08-3.257c.143-.441.555-.726 1.01-.726h4.352c.583 0 1.067.484 1.067 1.067s-.484 1.067-1.067 1.067h-3.584l-.37 1.123h1.778a3.241 3.241 0 0 1 3.243 3.243 3.241 3.241 0 0 1-3.243 3.243Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgBackward5
